var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgX = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 15,
  height: 15,
  fill: "none",
  viewBox: "0 0 15 15"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M8.927 6.348 14.511 0h-1.323L8.339 5.512 4.467 0H0l5.856 8.335L0 14.992h1.323l5.12-5.82 4.09 5.82H15zm-1.812 2.06-.594-.83L1.801.975h2.032l3.81 5.33.593.83 4.952 6.928h-2.032z"
})));
export default SvgX;